import React from 'react';

import { AboutUs, Chef, FindUs, Footer, Gallery, Intro, Header, Laurels, SpecialMenu } from './container';
// Add intro above
import { Navbar } from './components';
import './App.css';

const App = () => (
  <div>
    <Navbar />
    <Header />
    <AboutUs />
    <SpecialMenu />
    <Chef />
    <Intro />
    <Laurels />
    <Gallery />
    <FindUs />
    <Footer />
  </div>
);

export default App;
